import type { FC, ReactNode } from "react";
import { Button } from "react-aria-components";
import {
  TeammateLabel,
  type TeammateLabelProps,
} from "../teammate/teammateLabel.js";

export interface CustomerTimelineCallParticipant extends TeammateLabelProps {
  id: string;
}

export interface CustomerTimelineCallProps {
  title: ReactNode;
  participants: readonly CustomerTimelineCallParticipant[];
  duration?: string;
  /** Pressing the title or duration opens the call. */
  openCall: () => void;
}

/** Recording facts for a single call, with no data fetching or route knowledge. */
export const CustomerTimelineCall: FC<CustomerTimelineCallProps> = (props) => {
  const { title, participants, duration, openCall } = props;

  return (
    <div className="max-w-2xl min-w-0">
      {/* The no-break space keeps the duration on the title's last line. That
          only holds while both flow as one line of text, so the button wraps
          both. */}
      <Button
        className="group block cursor-pointer rounded-sm text-left text-sm font-medium text-foreground focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        onPress={openCall}
      >
        <span className="whitespace-nowrap">
          <span className="whitespace-normal underline decoration-gray-300 underline-offset-2 transition-colors group-hover:decoration-gray-500">
            {title}
          </span>
          {duration && (
            <span className="text-xs font-normal text-muted-foreground">
              {"\u00a0\u00a0"}
              {duration}
            </span>
          )}
        </span>
      </Button>

      {participants.length > 0 && (
        <div className="mt-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-muted-foreground">
          {participants.map((participant) => (
            <TeammateLabel
              key={participant.id}
              name={participant.name}
              kind={participant.kind}
              isAvatarHidden={participant.isAvatarHidden}
            />
          ))}
        </div>
      )}
    </div>
  );
};
